import { Autocomplete, AutocompleteProps, FormControl, MenuItem, TextField } from '@mui/material'

export type IOvAutoCompleteOption = Record<string, string | number | null | any>

export interface IOvAutoCompleteProps
  extends AutocompleteProps<any, boolean | undefined, boolean | undefined, boolean | undefined> {
  options: Record<string, any>[]
  error?: boolean
  renderOption?: (option: any) => JSX.Element
  optionLabelKey: string
  renderOptionProps?: any
  label: string
  key?: any
  helperText?: string
  readOnly?: boolean
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  sx?: Record<string, any>
}

export function OvAutoComplete({
  renderOption,
  options,
  error,
  label,
  optionLabelKey,
  renderInput,
  color,
  sx,
  ...rest
}: IOvAutoCompleteProps): React.ReactElement {
  const handleGetOptionLabel = (option: any) => {
    if (typeof option === 'string') return option
    if (optionLabelKey) return option[optionLabelKey]
    return option as string
  }

  const _renderOption = (props: Record<string, any>, option: any) => {
    const { key, ...optionsProps } = props

    return (
      <MenuItem
        key={key}
        component="li"
        {...optionsProps}
        value={option}>
        {renderOption ? renderOption(option) : option[optionLabelKey]}
      </MenuItem>
    )
  }

  return (
    <FormControl
      error={error}
      variant="outlined"
      sx={{ minWidth: { md: 130 }, width: '100%' }}>
      <Autocomplete
        id="ov-autocomplete"
        options={options}
        fullWidth
        getOptionLabel={handleGetOptionLabel}
        renderOption={(props, option) => _renderOption(props, option)}
        renderInput={params =>
          renderInput ? (
            renderInput(params)
          ) : (
            <TextField
              {...params}
              inputProps={params.inputProps}
              label={label}
              color={color}
              sx={sx}
            />
          )
        }
        {...rest}
      />
    </FormControl>
  )
}
